import { ApplicationQuestionReviewItem } from '../../../../../components/ApplicationQuestionReviewItem';
import { DropDownBox } from '@apply/components';
import { usePropertyDevelopmentType } from '../../../../../../queries/PropertyFields/BridgeFields';
import { PropertyDevelopmentType, PropertyDevelopmentTypeOptions } from '@apply/constants';

export interface PropertyDevelopmentProps {
    propertyGuid: string;
    width?: string;
    required?: boolean;
    isReview?: boolean;
}

export const PropertyDevelopment: React.FC<PropertyDevelopmentProps> = ({
    propertyGuid,
    required = false,
    width,
    isReview = false,
}) => {
    const label = (
        <>
            Select the most <strong>accurate</strong> description of this property
        </>
    );

    const labelReview = 'Project Type';

    const [propertyDevelopmentType, set_propertyDevelopmentType] = usePropertyDevelopmentType(propertyGuid);

    // New Acquisition is set automatically for Acquisition Bridge applications, never picked by hand.
    const propertyDevelopmentList = PropertyDevelopmentTypeOptions.filter(
        (o) => o.id !== PropertyDevelopmentType.NewAcquisition
    ).map((o) => ({
        display: o.name,
        value: o.id,
    }));

    // Looked up against the full option list so an already-stored New Acquisition still has a label.
    const findPropertyDevelopmentByValue = (value: number | undefined) => {
        return PropertyDevelopmentTypeOptions.find((o) => o.id == value)?.name;
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={labelReview}
                    value={findPropertyDevelopmentByValue(propertyDevelopmentType)}
                />
            ) : (
                <DropDownBox
                    id={'propertyDevelopmentTypeDropDown'}
                    value={propertyDevelopmentType}
                    onChange={(value) => set_propertyDevelopmentType(value)}
                    required={required}
                    dataSource={propertyDevelopmentList}
                    displayExpr='display'
                    valueExpr='value'
                    width={width}
                    label={label}
                />
            )}
        </>
    );
};
